export const RESOURCE_STATUS = {
  not_found: 'not_found',
  not_confirmed: 'not_confirmed',
  force_password_change: 'force_password_change',
  invalid_confirmation_token: 'invalid_confirmation_token',
  invalid_password_reset_token: 'invalid_password_reset_token',
  invalid_credentials: 'invalid_credentials',
};
